import { createFileRoute } from "@tanstack/react-router";
import { IntegrationsPage } from "../../components/Settings/Integrations/IntegrationsPage";

export const Route = createFileRoute("/settings/integrations")({
	component: IntegrationsPage,
});
